export function checkColor(value: any) {
  switch (value) {
    case "Pronto Para Beber":
      return 'rgba(6, 78, 59)'
    case "Aguardar":
      return 'rgba(30, 58, 138)'
    case "A Perder":
      return 'rgba(120, 53, 15)'
    case "Estragado":
      return 'rgba(127, 29, 29)'
  }
}